module.exports = __webpack_public_path__ + "img/circle3.13639176.svg";